import React from "react"
import classNames from "classnames"

import AlarmIcon from "../../../../assets/_V2/svg/AlarmIcon"

import Card1 from "./assets/Card1"
import Card2 from "./assets/Card2"

import styles from "./styles.module.scss"

export default {
	heading: (
		<span className={classNames(styles.heading, styles.colorGreen)}>
			<AlarmIcon />
			Управление временем
		</span>
	),
	textarea: (
		<>
			<span className={styles.textarea__desktop}>
				Пока мы будем заниматься рутиной и настраивать автоматизацию,
				<br />
				ты сможешь заняться тем, что приносит прибыль бизнесу.
			</span>
			<span className={styles.textarea__tablet}>
				Пока мы будем заниматься рутиной и настраивать автоматизацию,
				<br />
				ты сможешь заняться тем, что приносит прибыль бизнесу.
			</span>
			<span className={styles.textarea__mobile}>
				Пока мы будем заниматься рутиной и настраивать автоматизацию, ты сможешь
				заняться тем, что приносит прибыль бизнесу.
			</span>
		</>
	),
	cardList: [
		{
			id: 0,
			heading: "В одиночку",
			textarea:
				"Всегда дольше. Приходится выбирать, на что сегодня потратить время",
			content: (
				<ul className={classNames(styles.ul, styles.colorGreen)}>
					<li>Разбираться в настройках ЕГАИС или искать мебель для зала</li>
					<li>Заполнять техкарты или писать посты для соцсетей</li>
					<li>Идти в налоговую или выбирать поставщика</li>
				</ul>
			),
			mediaContent: <Card1 />,
		},
		{
			id: 1,
			heading: "С Quick Resto",
			textarea: "Есть время, чтобы делать лучший сервис и находить точки роста",
			content: (
				<ul className={classNames(styles.ul, styles.colorGreen)}>
					<li>
						Оптимизировать бизнес и создавать условия, при которых не надо быть
						в заведении 24/7
					</li>
					<li>Сократить расходы на закупки и повысить маржинальность</li>
					<li>Создать атмосферу, которую полюбят гости</li>
				</ul>
			),
			mediaContent: <Card2 />,
		},
	],
}
